import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZcliExamplesComponent } from './zcli-examples.component';
import { ZuiDocsTextModule } from '../docs-text';

@NgModule({
  declarations: [ ZcliExamplesComponent ],
  imports: [
    CommonModule,
    ZuiDocsTextModule,
    ZefCopyToClipboardModule,
    ZefScrollbarComponent
  ],
  exports: [ ZcliExamplesComponent ]
})
export class ZuiZcliExamplesModule {}
